var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsterisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.182,
    height: 8.109,
    viewBox: "0 0 7.182 8.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asterisk",
    transform: "translate(-201.453 -114.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2645",
    "data-name": "Path 2645",
    d: "M208.388,190.566l-3.087-1.787a4.56,4.56,0,0,0,.257.433V189.2a.485.485,0,0,0-.257-.433l-3.086-1.787a.51.51,0,0,0-.514.88l3.087,1.787a4.562,4.562,0,0,0-.257-.433v.014a.485.485,0,0,0,.257.433l3.086,1.787A.51.51,0,0,0,208.388,190.566Z",
    transform: "translate(0 -70.363)",
    fill: "#f71717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2646",
    "data-name": "Path 2646",
    d: "M330.3,118.848v-3.56a.508.508,0,0,0-1.015,0v3.56A.508.508,0,0,0,330.3,118.848Z",
    transform: "translate(-124.737 0)",
    fill: "#f71717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2647",
    "data-name": "Path 2647",
    d: "M330.3,266.688v-3.56a.508.508,0,0,0-1.015,0v3.56A.508.508,0,0,0,330.3,266.688Z",
    transform: "translate(-124.737 -144.266)",
    fill: "#f71717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2648",
    "data-name": "Path 2648",
    d: "M202.215,192.542q3.087-1.787,6.173-3.56a.51.51,0,0,0-.514-.88q-3.087,1.787-6.173,3.56A.51.51,0,0,0,202.215,192.542Z",
    transform: "translate(0 -71.46)",
    fill: "#f71717"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/Asterisk.07f7ebd5371f70308edfa22de6f49e04.svg";
export { ForwardRef as ReactComponent };